import { useMemo } from 'react';
import { Row, Cell } from '../../../hooks/usePerformanceDetails';

interface Params {
  rows: Row[] | null | undefined;
  filter: string;
}

export const useFilteredRows = ({ rows, filter }: Params): Row[] | null => {
  return useMemo(() => {
    if (!rows) {
      return null;
    }

    if (!filter) {
      return rows;
    }

    const filterLower = filter.toLowerCase();

    const matchesFilter = (cells: Cell[]): boolean => {
      return cells.some(cell => cell.text.toLowerCase().includes(filterLower));
    };

    return rows
      .filter(row => {
        if (row.isTotal) {
          return true;
        }

        const rowMatches = matchesFilter(row.cells);
        const hasMatchingChildren = row.childRows?.some(child => matchesFilter(child.cells));

        return rowMatches || hasMatchingChildren;
      })
      .map(row => ({
        ...row,
        childRows: row.childRows?.filter(child => matchesFilter(child.cells)),
      }));
  }, [rows, filter]);
};
